import { HttpMethod } from "@/types/https";
import { getAccessToken } from "../../workchestra/handler/auth";
import { apiAerotrakCall } from "../base";
import { AEROTRAK_ENDPOINT } from "../endpoint";
import {
  normalizeStandardResponse,
  StandardResponse,
  StandardPaginatedListResponse,
} from "@/types/standard-response";

export interface AeroTrakAppDto {
  id: number;
  name: string;
  description?: string;
  iconLibrary?: string;
  iconName?: string;
  iconVariant?: string | null;
  iconColor?: string | null;
  url: string;
  status: string;
  isAvailable: boolean;
  isAssigned: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface GetAppsByUserRoleResponse {
  apps: AeroTrakAppDto[];
}

export interface FetchAppsParams {
  status?: string;
  currentPage?: number;
  itemsPerPage?: number;
}

export const fetchAeroTrakApps = async (
  params: FetchAppsParams = {}
): Promise<StandardPaginatedListResponse<AeroTrakAppDto>> => {
  getAccessToken();
  const raw = await apiAerotrakCall<any>({
    url: AEROTRAK_ENDPOINT.AEROTRAK_APPS,
    method: HttpMethod.GET,
    params: {
      status: params.status,
      currentPage: params.currentPage,
      itemsPerPage: params.itemsPerPage,
    },
  });
  return normalizeStandardResponse<AeroTrakAppDto>(raw, {
    assumeList: true,
  }) as StandardPaginatedListResponse<AeroTrakAppDto>;
};

export const fetchAeroTrakAppsByUserRole = async (): Promise<
  StandardPaginatedListResponse<AeroTrakAppDto>
> => {
  getAccessToken();
  const raw = await apiAerotrakCall<any>({
    url: AEROTRAK_ENDPOINT.AEROTRAK_APPS_BY_USER_ROLE,
    method: HttpMethod.GET,
  });
  return normalizeStandardResponse<AeroTrakAppDto>(raw, {
    assumeList: true,
  }) as StandardPaginatedListResponse<AeroTrakAppDto>;
};

export type AddUserAppDto = {
  userAppId: number;
  appId: number;
  assignedAt: string;
};
export const addAeroTrakUserApp = async (
  appId: number
): Promise<StandardResponse<AddUserAppDto>> => {
  getAccessToken();
  const raw = await apiAerotrakCall<any>({
    url: AEROTRAK_ENDPOINT.AEROTRAK_USER_APPS,
    method: HttpMethod.POST,
    body: { appId },
  });
  return normalizeStandardResponse<AddUserAppDto>(raw);
};

export const removeAeroTrakUserApp = async (appId: number): Promise<any> => {
  getAccessToken();
  const raw = await apiAerotrakCall<any>({
    url: `${AEROTRAK_ENDPOINT.AEROTRAK_USER_APPS}/${appId}`,
    method: HttpMethod.DELETE,
  });
  return normalizeStandardResponse<{ appId: number; removedAt: string }>(raw);
};

export const fetchAeroTrakUserAssignedApps = async (): Promise<
  StandardPaginatedListResponse<AeroTrakAppDto>
> => {
  getAccessToken();
  const raw = await apiAerotrakCall<any>({
    url: AEROTRAK_ENDPOINT.AEROTRAK_USER_ASSIGNED_APPS,
    method: HttpMethod.GET,
  });
  return normalizeStandardResponse<AeroTrakAppDto>(raw, {
    assumeList: true,
  }) as StandardPaginatedListResponse<AeroTrakAppDto>;
};

export async function getAeroTrakAppDtos(): Promise<AeroTrakAppDto[]> {
  const resp = await fetchAeroTrakUserAssignedApps();
  return resp.data;
}
